import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxurious%20private%20cinema%20room%20with%20warm%20ambient%20lighting%2C%20plush%20velvet%20red%20seats%2C%20elegant%20dark%20wood%20paneling%2C%20soft%20golden%20accent%20lights%2C%20premium%20theater%20atmosphere%2C%20sophisticated%20interior%20design%2C%20cozy%20and%20intimate%20setting%2C%20professional%20architectural%20photography%20with%20warm%20tones&width=1800&height=900&seq=hero-bg-adult-cinema&orientation=landscape"
        alt="成人影院专业私密观影体验"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
            专业私密观影体验指南
          </h1>
          <p className="mt-5 text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
            为成年人提供专业、客观的成人影院选择指导，涵盖观影礼仪、隐私保护与合规运营知识，助您享受安全舒适的私密观影体验。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/selection-guide"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              开始了解
            </Link>
            <Link
              to="/category/faq-category"
              className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-md backdrop-blur-sm transition-all duration-300 whitespace-nowrap cursor-pointer text-sm border border-white/30"
            >
              常见问题
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}